module.exports = __webpack_public_path__ + "static/media/star.74e30a27.svg";